import { h } from "omi";

import { NWProjectShareDialog } from "@/pages/project/features/share";

import { ModalProps } from "../../models";

export type ShareModalData = {};
type Props = ModalProps<ShareModalData>;

export const ShareModal = (props: Props) => {
  return <NWProjectShareDialog close={props.close} />;
};
